'use client';

import { DataTableFacetedFilter } from './data-table-faceted-filter';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

export function DataTableToolbar({
  table,
  facetedFilters = [],
  showSearch = false,
  searchValue = '',
  onSearchChange,
}) {
  const isFiltered = table.getState().columnFilters.length > 0;

  return (
    <div className="w-full mb-1">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        {/* Faceted filters */}
        {facetedFilters.length > 0 && (
          <div className="flex items-center space-x-2 overflow-x-auto sm:flex-wrap sm:overflow-visible">
            {facetedFilters.map(({ columnId, title, options }) => {
              const column = table.getColumn(columnId);
              return column ? (
                <DataTableFacetedFilter
                  key={columnId}
                  column={column}
                  title={title}
                  options={options}
                />
              ) : null;
            })}

            {/* Optional reset button */}
            {/* {isFiltered && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => table.resetColumnFilters()}
              >
                Reset
                <X className="ml-1 h-4 w-4" />
              </Button>
            )} */}
          </div>
        )}

        {/* Search input */}
        {showSearch && (
          <div className="mt-2 sm:mt-0 sm:ml-auto flex flex-wrap sm:flex-nowrap items-center gap-2 w-full sm:w-auto">
            <input
              type="text"
              placeholder="Ieškoti..."
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className="border rounded px-2 py-1 flex-1 min-w-[150px] sm:flex-none sm:w-64"
            />
            {searchValue && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onSearchChange('')}
                className="flex items-center gap-1 whitespace-nowrap"
              >
                <X className="h-4 w-4" />
                <span>Išvalyti</span>
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
